import { render, staticRenderFns } from "./integrantesDependencia.vue?vue&type=template&id=0780b206"
import script from "./integrantesDependencia.vue?vue&type=script&lang=js"
export * from "./integrantesDependencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports